module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<div class=\"prop-header\"><span class=\"prop-label\">Page</span></div>\r\n    <div class=\"row\">\r\n        <div class=\"col-md-4 prop-sublabel\">\r\n            Color\r\n        </div>\r\n        <div class=\"col-md-8 nopadding\" >\r\n            <input id=\"themePageColor\" name=\"themePageColor\" type=\"color\" value=\"")
    ; __append(escapeFn( pageBgColor ))
    ; __append("\" style=\"width: 20px; border: 1px solid #aaaaaa; padding: 0px; height: 23px;\" />\r\n            <input id=\"pageBgColor\" name=\"pageBgColor\" type=\"text\" value=\"")
    ; __append(escapeFn( pageBgColor ))
    ; __append("\" maxlength=\"7\" class=\"color-picker-text\" />\r\n        </div>\r\n    </div>\r\n    <div class=\"row\">\r\n        <div class=\"col-md-4 prop-sublabel\">\r\n            Picture\r\n        </div>\r\n        <div class=\"col-md-8 nopadding\" >\r\n            <select name=\"pageBgImage\" class=\"style-font\" style=\"width: 90%;\" id=\"pageBgImage\">\r\n                <option value=\"None\">None</option>\r\n            </select>\r\n        </div>\r\n    </div>\r\n")
  }
  return __output;

}